import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, DownloadX, GFunc, LocaleX, ReqX, ZTime } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, Spacer, VStack, XButton, XDiv, XScroll, XText } from "IZOX/_X";
import PAContainer from "../shared/PAContainer/PAContainer";
import { PageFlipper } from "IZOX/BLOCKS/Libs";
import _ from "lodash";
import QUICKUI from "shared/QUICKUI";
import PolicyUtils from "shared/_utils/PolicyUtils";
import ViewACP from "./_gears/ViewACP";

/**
 * @augments {Component<Props, State>}
 */
class PAACPM extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {
      docs: [],
      count: 0,
      page: 0,
      pageSize: 10,
      loading: false
    };
  }

  componentDidMount(){
    this._setAllStates(() => {
      this.GetACPs();
    });
  }

  componentDidUpdate(prevProps){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PAACPM.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = () => {};
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  GetACPs = async () => {
    let {page, pageSize} = this.state;
    this.setState({ loading: true });
    let res = await ReqX.SendBE("/Web/Agent/ListACPs", {
      page,
      pageSize
    });
    let {Success, payload} = res;
    this.setState({ loading: false });
    if(Success){
      let {docs, count} = payload;
      this.setState({ docs, count });
    }else{
      GFunc.Alert(payload, "error");
    }
  }

  _onPageSizeChange = (pageSize) => {
    this.setState({ pageSize, page: 0 }, () => this.GetACPs());
  }

  _onPageChange = (page) => {
    this.setState({ page }, () => this.GetACPs());
  }

  _toView = (docID) => {
    GFunc.Backdrop(() => {
      return (
        <ViewACP docID={docID}/>
      );
    }, {}, false);
  }

  _download = async (docID) => {
    try{
      GFunc.Loading(true);
      let res = await ReqX.SendBE("/Web/Agent/DownloadACP", { docID });
      let {Success, payload} = res;
      if(Success){
        await DownloadX.PDF(payload, payload?.filename || `${docID}.pdf`);
      }else{
        GFunc.Alert(payload, "error");
      }
    }finally{
      GFunc.Loading(false);
    }
  }

  renderHeader(){
    return (
      <HStack mB={16}>
        <XText bold color={ColorX.CSS("Leaf")} fontSize={16}>
          {LocaleX.Parse({
            EN: "ACP",
            TC: "ACP"
          })}
        </XText>
        <Spacer/>
      </HStack>
    );
  }

  renderRow(doc, idx){
    let {_id, status, startAt, endAt, issueAt, _maid, _policy} = doc ?? {};
    let _status = PolicyUtils.GetStatus(status);
    let helperName = _maid?.fullName ?? "-";
    let policyNo = _policy?.policyNo || doc?.policyID || "-";

    return (
      <VStack key={_id || idx} fullWidth bgColor={ColorX.CSS("pureWhite")} p={12} round={8} spacing={8}>
        <HStack fullWidth>
          <XText bold fontSize={13} color={ColorX.CSS("Axit")} overflowWrap="anywhere">{_id}</XText>
          <Spacer/>
          {_status &&
            <XDiv bgColor={_status.bgColor} pH={8} pV={2} round={4}>
              <XText color={_status.color} fontSize={11}>
                {LocaleX.Parse(_status.label)}
              </XText>
            </XDiv>
          }
        </HStack>
        <XText fontSize={12}>
          {LocaleX.Parse({ EN: "Helper", TC: "助理" })}: {helperName}
        </XText>
        <XText fontSize={12}>
          {LocaleX.Parse({ EN: "Policy No.", TC: "保單編號" })}: {policyNo}
        </XText>
        <XText fontSize={11} color={ColorX.CSS("Gray4")}>
          {(startAt ? ZTime.Moment(startAt).format("DD MMM YYYY") : "-")
            + " – "
            + (endAt ? ZTime.Moment(endAt).format("DD MMM YYYY") : "-")}
          {issueAt ? `  |  ${ZTime.Moment(issueAt).format("DD MMM YYYY")}` : ""}
        </XText>
        <HStack spacing={8} fullWidth HAlign="]">
          <XButton onPress={() => this._toView(_id)}
            bgColor={ColorX.CSS("bgBlue")} color={ColorX.CSS("blue")}
            pH={12} padding={6} round={5}>
            <XText fontSize={12}>
              {LocaleX.Parse({ EN: "View", TC: "查看" })}
            </XText>
          </XButton>
          <XButton onPress={() => this._download(_id)}
            bgColor={ColorX.CSS("Axit")} color={ColorX.CSS("pureWhite")}
            pH={12} padding={6} round={5}>
            <XText fontSize={12}>
              {LocaleX.Parse({ EN: "Download", TC: "下載" })}
            </XText>
          </XButton>
        </HStack>
      </VStack>
    );
  }

  renderList(){
    let {docs, page, pageSize, count} = this.state;
    if(_.isEmpty(docs)){
      return QUICKUI.NoDocs({
        EN: "There are no ACP records.",
        TC: "沒有任何 ACP 紀錄。"
      });
    }
    return (
      <VStack fullWidth spacing={10}>
        {_.map(docs, (o, i) => this.renderRow(o, i))}
        <PageFlipper totalDocs={count}
          page={page}
          pageSize={pageSize}
          onPageSizeChange={this._onPageSizeChange}
          onPageChange={this._onPageChange}
          popupPosition="top"
          mainColor={ColorX.CSS("Axit")} />
      </VStack>
    );
  }

  render(){
    return (
      <PAContainer>
        <VStack bgColor={ColorX.CSS("NotQuiteWhite")} fullWidth fullHeight p={12}>
          {this.renderHeader()}
          <XScroll fullWidth>
            {this.renderList()}
          </XScroll>
        </VStack>
      </PAContainer>
    );
  }

}

export default observer(PAACPM);
